import {useEffect, useRef, useState} from "react"
import useClickOutside from "../hooks/useClickOutside"
import QuestionMark from "./vectors/QuestionMark";

export default function Tooltip({ content, titleText = null, size = null, fill = null, stroke = null, onClick = null }) {
    const [isTooltipShown, setIsTooltipShown] = useState(false)
    const tooltipRef = useRef(null)
    const questionIconRef = useRef(null)
    const [tooltipAlignClasses, setTooltipAlignClasses] = useState('')

    useEffect(() => {
        if (!isTooltipShown) {
            return;
        }

        const questionIconRight = questionIconRef.current.getBoundingClientRect().right
        const questionIconLeft = questionIconRef.current.getBoundingClientRect().left
        const tooltipWidth = 192

        if (questionIconRight + (tooltipWidth / 2) > window.innerWidth ) {
            setTooltipAlignClasses('right-0')
            return
        }

        if (questionIconLeft - (tooltipWidth / 2) <=  0 ) {
            setTooltipAlignClasses('left-0')
            return;
        }

        setTooltipAlignClasses('left-1/2 -translate-x-1/2')

    }, [isTooltipShown]);
    
    useClickOutside(tooltipRef, () => setIsTooltipShown(false))

    return (
        <div className="relative flex">
            <div ref={questionIconRef} className="focus:outline-none text-secondary-blue cursor-pointer" onClick={onClick === null ? () => setIsTooltipShown(!isTooltipShown) : onClick}>
                {titleText || <QuestionMark fill={fill} size={size} stroke={stroke} />}
            </div>

            <p ref={tooltipRef} className={`${isTooltipShown ? '' : 'hidden'} ${tooltipAlignClasses} absolute z-50 bg-tertiary-blue w-60 px-5 py-3 mt-7 transition-all text-center text-gray-600 rounded-lg shadow-sm shadow-gray-200`}>
                {content}
            </p>
        </div>
    )
}